// extracted by mini-css-extract-plugin
export var solutionImage = "SolutionImg-module--solution-image--Rz5D+";